import { render, staticRenderFns } from "./MinistryMeeting.vue?vue&type=template&id=40b47211&scoped=true&"
import script from "./MinistryMeeting.vue?vue&type=script&lang=ts&"
export * from "./MinistryMeeting.vue?vue&type=script&lang=ts&"
import style0 from "./MinistryMeeting.vue?vue&type=style&index=0&id=40b47211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b47211",
  null
  
)

export default component.exports